import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'
import './Footer.css'

function Footer() {
  const { t } = useTranslation()
  const location = useLocation()
  const isLandingPage = location.pathname === '/'
  const currentYear = new Date().getFullYear()

  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          <div className='footer-section footer-section-brand'>
            <h3>Runless</h3>
            <p>{t('footer.description')}</p>
            <div className='cloudsoft-badge'>
              <a
                href='https://www.cloudsoft.com.pl'
                target='_blank'
                rel='noopener noreferrer'
                className='cloudsoft-link'
              >
                <span className='powered-by'>{t('footer.poweredBy')}</span>
                <span className='cloudsoft-name'>{t('branding.cloudSoft')}</span>
              </a>
            </div>
          </div>

          <div className='footer-section'>
            <h4>{t('footer.product')}</h4>
            <ul>
              <li>
                {isLandingPage ? (
                  <a href='#features'>{t('footer.features')}</a>
                ) : (
                  <Link to='/#features'>{t('footer.features')}</Link>
                )}
              </li>
              <li>
                {isLandingPage ? (
                  <a href='#pricing'>{t('footer.pricing')}</a>
                ) : (
                  <Link to='/#pricing'>{t('footer.pricing')}</Link>
                )}
              </li>
              <li>
                <Link to='/docs'>{t('footer.documentation')}</Link>
              </li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4>{t('footer.company')}</h4>
            <ul>
              <li>
                {isLandingPage ? (
                  <a href='#about'>{t('footer.about')}</a>
                ) : (
                  <Link to='/#about'>{t('footer.about')}</Link>
                )}
              </li>
              <li>
                <a href='https://www.cloudsoft.com.pl/contact' target='_blank' rel='noopener noreferrer'>
                  {t('footer.contact')}
                </a>
              </li>
              <li>
                <a href='https://www.cloudsoft.com.pl' target='_blank' rel='noopener noreferrer'>
                  {t('branding.cloudSoft')}
                </a>
              </li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4>{t('footer.legal')}</h4>
            <ul>
              <li>
                <Link to='/privacy'>{t('footer.privacy')}</Link>
              </li>
              <li>
                <Link to='/cookie-policy'>{t('footer.cookiePolicy')}</Link>
              </li>
              <li>
                <a href='#terms'>{t('footer.terms')}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className='footer-bottom'>
          <p>
            &copy; {currentYear}{' '}
            <a
              href='https://www.cloudsoft.com.pl'
              target='_blank'
              rel='noopener noreferrer'
              className='cloudsoft-copyright'
            >
              {t('branding.cloudSoft')}
            </a>
            . Runless. {t('footer.rights')}.
          </p>
          <div className='footer-social'>
            <a
              href='https://x.com/CloudSoftComPL'
              target='_blank'
              rel='noopener noreferrer'
              aria-label={t('footer.x')}
              className='social-link'
            >
              <svg viewBox='0 0 24 24' fill='currentColor' className='social-icon'>
                <path d='M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' />
              </svg>
            </a>
            <a
              href='https://www.linkedin.com/in/marcin-malinowski-b497a76/'
              target='_blank'
              rel='noopener noreferrer'
              aria-label={t('footer.linkedin')}
              className='social-link'
            >
              <svg viewBox='0 0 24 24' fill='currentColor' className='social-icon'>
                <path d='M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z' />
              </svg>
              <span>{t('footer.linkedin')}</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
